import type {
    GetHeaderParams,
    OfficeActionHeaderService,
} from '../office-action-header-service';
import type { OfficeActionHeader } from '../../types/office-action-header';

/**
 * 审查意见通知书元数据服务的 Mock 实现
 */
export class MockOfficeActionHeaderService implements OfficeActionHeaderService {
    async getHeader(params: GetHeaderParams): Promise<OfficeActionHeader> {
        // 模拟异步延迟
        await new Promise((resolve) => setTimeout(resolve, 100));

        // 返回基于截图中的示例数据
        return {
            documentType: '发明专利',
            authority: '国家知识产权局',
            documentNumber: '100044',
            issueDate: '2024年08月30日',
            agency: {
                name: '北京风雅颂专利代理有限公司',
                address:
                    '北京市朝阳区农展馆南路 13 号瑞辰国际中心 4 层 509',
                contactPerson: '李晓楠',
                phoneNumber: '13812751900',
            },
            applicationNumber: '202210195149.4',
            documentSequenceNumber: '202408300225630',
            applicant: '苏州慧工云信息科技有限公司',
            inventionTitle: 'MRP 运算验证测试方法、装置、设备和存储介质',
            barcodes: [
                '*202210195149.4*',
                '*202408300225630*',
            ],
        };
    }
}
